import React, { JSX, useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../../../common/CmnContext';
import { LiveReserveContext } from '../../LiveLessonReseveContext';
import Modal from '../../../../../common/Modal';
import LiveReserveDateModal from './modal/LiveReserveDateModal';

import {
  formatDate, formatTime, formatTimeAddMin,
} from '../../../../../../util/utility';


// 日時選択
function LiveReserveDate() {

  const { isPc } = useContext(cmnContext);
  const {
    lsnMin, calendar, selectedScheduleId,
  } = useContext(LiveReserveContext);


  const [dispDate, setDispDate] = useState<string>('');
  const [dispDateTime, setDispDateTime] = useState<string>('');
  // モーダル表示
  const [isDispModal, setIsDispModal] = useState<boolean>(false);


  // 選択時にモーダルを閉じる
  useEffect(() => {
    setIsDispModal(false);
  }, [selectedScheduleId])


  // 予約日時
  useEffect(() => {
    for(const date in calendar) {
      const times = calendar[date];
      for(const time in times) {
        if(times[time] == selectedScheduleId) {
          setDispDate(formatDate(date));
          // 時間を"HH:MM"に整形
          setDispDateTime(`${formatTime(time)}〜${formatTimeAddMin(time, lsnMin)}`);
        }
      }
    }
  }, [calendar, selectedScheduleId])


  return (
    <>
      <div style={{
          display: 'flex',
          alignItems: 'end',
          justifyContent: 'space-between',
          marginTop: '20px',
          marginBottom: '30px',
        }}>

          <div>
            <label className="control-label" style={{
              margin: '15px 0 10px 0',
              backgroundColor: '#eaffea',
              padding: '0.25em 3em 0.25em 0.5em',
              borderLeft: 'solid 5px #3c8c3c',
            }}>レッスンの日程</label>
            <div style={{marginLeft: '5px'}}>
              <p style={{
                margin: 0,
                fontSize: '16px',
                // バリデーションStyle
                ...(!selectedScheduleId ? 
                  {
                    backgroundColor: 'red',
                    color: '#fff',
                    padding: '3px 10px',
                  }
                  : {}
                )
              }}>
                {(dispDate && dispDateTime) ?
                  <>{dispDate}&nbsp;&nbsp;{dispDateTime}</>
                :
                  <>日程を選んでください</>
                }
              </p>
            </div>
          </div>

          <div style={{marginRight: isPc? '5px':0}}>
            <button
              type="button"
              className='btn btn-success'
              style={{
                width: '100%',
                margin: isPc? '10px 0 5px' : '5px 0 5px',
              }}
              onClick={() => setIsDispModal(true)}
            >
              {(selectedScheduleId)? '選び直す' : '日程を選ぶ' }
            </button>
          </div>

        </div>

        {/* 選択モーダル */}
        <Modal
          comp = {<LiveReserveDateModal />}
          isDispModal={isDispModal}
          setIsDispModal={setIsDispModal}
          isDispClose={true}
        />
    </>
  );
}
  
export default LiveReserveDate;